import React, { useRef, useState } from 'react'
import { Formik } from 'formik'
import * as Yup from "yup";
import { createDiscount, updateDiscount } from '../../redux/action/discount';

function codeGenerator(length) {
    const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let randomString = '';

    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * alphabet.length);
        randomString += alphabet.charAt(randomIndex);
    }

    return randomString;
}

const SignupSchema = Yup.object().shape({
    code: Yup.string().required("Discount code is required"),
    discountAmount: Yup.number()
        .typeError("Discount amount must be a number")
        .required("Discount amount is required")
        .positive("Discount amount must be a positive number"),
});

const DiscountModal = (props) => {
    const formikRef = useRef(null);
    const [code, setCode] = useState(codeGenerator(10))

    const handleFormSubmit = async (values) => {
        let res;
        if (props?.defaultValue?._id) {
            res = await updateDiscount({ ...values, _id: props?.defaultValue?._id })
        } else {
            res = await createDiscount(values);
        }

        if (res?.success) {
            formikRef.current.resetForm();
            return (window.location.href = `/discount`)
        }
    };

    const resetCode = () => {
        setCode(codeGenerator(10))
    }

    return (
        <div
            className={`modal fade ${props.isModalOpen ? 'show' : ''}`}
            id={props.modalId}
            aria-hidden={true}
        >
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header border-0 d-flex">
                        <div className="text-center">
                            <h1 className=" text-primary">Add Discount</h1>
                        </div>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                    </div>
                    <div className="modal-body">
                        <div className="modal-body p-0">
                            <Formik
                                innerRef={formikRef}
                                initialValues={{
                                    code: props?.defaultValue?.code || code,
                                    discountAmount: props?.defaultValue?.discountAmount || 0,
                                }}
                                enableReinitialize
                                validationSchema={SignupSchema}
                                onSubmit={handleFormSubmit}
                            >
                                {({
                                    values,
                                    errors,
                                    touched,
                                    handleBlur,
                                    handleChange,
                                    handleSubmit,
                                }) => (
                                    <form className="form">
                                        <div className="row mb-8">
                                            <div className="col-xl-12 position-relative">
                                                <div className="form-group">
                                                    <label htmlFor="code" className="fs-6 fw-bold"><span className="required">Discount Code</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-solid"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        name="code"
                                                        id="code"
                                                        value={values?.code}
                                                    />
                                                    <div className='position-absolute top-0 mt-9 me-8 cursor-pointer end-0' onClick={resetCode}>
                                                        <svg fill="#000000" height="20px" width="20px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" viewBox="0 0 489.533 489.533" space="preserve" transform="rotate(-45)">
                                                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                                            <g id="SVGRepo_iconCarrier">
                                                                <g>
                                                                    <path d="M268.175,488.161c98.2-11,176.9-89.5,188.1-187.7c14.7-128.4-85.1-237.7-210.2-239.1v-57.6c0-3.2-4-4.9-6.7-2.9 l-118.6,87.1c-2,1.5-2,4.4,0,5.9l118.6,87.1c2.7,2,6.7,0.2,6.7-2.9v-57.5c87.9,1.4,158.3,76.2,152.3,165.6 c-5.1,76.9-67.8,139.3-144.7,144.2c-81.5,5.2-150.8-53-163.2-130c-2.3-14.3-14.8-24.7-29.2-24.7c-17.9,0-31.9,15.9-29.1,33.6 C49.575,418.961,150.875,501.261,268.175,488.161z"></path>
                                                                </g>
                                                            </g>
                                                        </svg>
                                                    </div>
                                                    {errors.code && touched.code ? (
                                                        <div className="text-danger mt-2" style={{ fontSize: "14px" }}>
                                                            {errors.code}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row mb-8">
                                            <div className="col-xl-12">
                                                <div className="form-group">
                                                    <label htmlFor="discountAmount" className="fs-6 fw-bold"><span className="required">Discount Amount</span></label>
                                                    <input
                                                        type="number"
                                                        className="form-control form-control-solid"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        name="discountAmount"
                                                        id="discountAmount"
                                                        value={values?.discountAmount}
                                                    />
                                                    {errors.discountAmount && touched.discountAmount ? (
                                                        <div className="text-danger mt-2" style={{ fontSize: "14px" }}>
                                                            {errors.discountAmount}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="separator mb-6"></div>
                                        <div className="d-flex justify-content-end">
                                            <button
                                                onClick={handleSubmit}
                                                type="submit"
                                                className="btn btn-primary"
                                            >
                                                <span className="indicator-label">Save</span>
                                            </button>
                                        </div>
                                    </form>
                                )}
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DiscountModal